import { useEffect, useRef } from 'react';
import { getHowlerSFX } from 'js/components/audio/howler';
import { useAudio } from 'js/context/AudioContext';

export function useSFX() {
  const { audioEnabled } = useAudio();
  const howlerSFX = useRef({});

  const playSFX = (key, vol = 0.5) => {
    const context = howlerSFX?.current?.play || false;
    if (audioEnabled && key && context) {
      const id = howlerSFX?.current?.play(key);
      howlerSFX.current.volume(vol, id);
    }
  };
  useEffect(() => {
    howlerSFX.current = getHowlerSFX();
    return () => {};
  }, []);

  return { playSFX };
}
